// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1Pdcw","colMaxWidth":"Table_colMaxWidth__10wo9"};